<template>
  <div :class="$style.container">
    <BaseIcon name="phone-alt" :class="[$style.phoneIco, { [$style.phoneIcoOutgoing]: isOutgoing }]" />
    <div>
      <div :class="[$style.title, { [$style.titleOutgoing]: isOutgoing }]">{{ title }}</div>
      <div :class="$style.info">
        <BaseIcon name="arrow-up" :class="[$style.arrow, { [$style.arrowUp]: isOutgoing }, { [$style.arrowRed]: isMissed }]" />
        <div :class="[$style.infoText, { [$style.infoTextOutgoing]: isOutgoing }]">{{ infoText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from '@/utils/date'
import { intervalToDuration } from 'date-fns'

export default {
  name: 'message-content-call',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMissed () {
      return !this.message.payload.duration
    },
    isOutgoing () {
      const { caller } = this.message.payload
      return caller === this.$store.getters['auth/user'].id
    },
    title () {
      if (this.isMissed) return this.$t('message.missedCall')
      if (this.isOutgoing) {
        return this.$t('message.outgoingCall')
      }
      return this.$t('message.incomingCall')
    },
    infoText () {
      return this.isMissed ? this.date : this.duration
    },
    date () {
      return format(new Date(this.message.created + 'Z'), 'd MMMM')
    },
    duration () {
      if (this.isMissed) return
      const { duration } = this.message.payload
      const { hours, minutes, seconds } = intervalToDuration({ start: new Date(0), end: new Date(duration) })
      let txt = this.$t('duration.sec', { n: seconds })
      if (minutes) {
        txt = this.$t('duration.min', { n: minutes }) + ` ${txt}`
      }
      if (hours) {
        txt = this.$t('duration.hour', { n: hours }) + ` ${txt}`
      }
      return txt
    }
  }
}
</script>

<style module lang="scss">
.container {
  display: flex;
  align-items: center;
}
.phoneIco {
  font-size: 22px;
  color: $text-light;
  margin-right: 8px;
  &Outgoing {
    color: $text-lightest;
  }
}
.title {
  // font-size: 14px;
  font-weight: 500;
  color: $text-dark;
  &Outgoing {
    color: $text-lightest;
  }
}
.info {
  display: flex;
  &Text {
    margin-left: 4px;
    font-size: 12px;
    color: $text-mid-dark;
    &Outgoing {
      color: $text-lightest;
    }
  }
}
.arrow {
  color: $text-colored;
  transform: rotate(225deg);
  &Up {
    transform: rotate(45deg);
  }
  &Red {
    color: $text-error;
  }
}
</style>
